import React from "react";
import styled from "styled-components";
import { Tooltip } from "antd";

import * as S from "@components/table";

import { TableHeading } from "@components/table-heading";
import { Column, SortOrder } from "@state/types";
import { mainTableMixin, Checkbox } from "./styled";
import SortIcon from "./sort-icon";

const StyledHCell = styled(S.THeadCell)`
  ${mainTableMixin};
  cursor: pointer;
`;

export interface TableHeadProps {
  selectAllChecked: boolean;
  onSelectAll: () => void;
  sortMode: SortOrder;
  onSortModeChange: (column: Column) => void;
}

type Align = "left" | "right" | "center";

export const TableHead = ({ selectAllChecked, onSelectAll, sortMode, onSortModeChange }: TableHeadProps) => {
  const [column, order] = sortMode;

  const colHeadings: {
    name: Column;
    label: string;
    align?: Align;
  }[] = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "status",
      label: "Status",
    },
    {
      name: "geographyArea",
      label: "Geography Area",
    },
    {
      name: "address",
      label: "Address",
    },
    {
      name: "rentFor",
      label: "Rent for m2",
      align: "right",
    },
    {
      name: "serviceCharge",
      label: "Service charge",
      align: "right",
    },
    {
      name: "lastUpdate",
      label: "Last update",
      align: "right",
    },
  ];

  return (
    <S.TableHead>
      <StyledHCell>
        <Tooltip title="Select all">
          <Checkbox checked={selectAllChecked} onClick={onSelectAll} />
        </Tooltip>
      </StyledHCell>
      {colHeadings.map(({ label, name, align = "left" }) => (
        <StyledHCell onClick={() => onSortModeChange(name)} textAlign={align}>
          <TableHeading level="4">
            {label} {column === name && <SortIcon direction={order} />}
          </TableHeading>
        </StyledHCell>
      ))}
    </S.TableHead>
  );
};
